import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, isRef as _isRef, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-84367c58"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "history"
};
const _hoisted_2 = {
  class: "history-body"
};
const _hoisted_3 = {
  key: 0,
  class: "list-card-container"
};
const _hoisted_4 = {
  class: "list-card-header vc"
};
const _hoisted_5 = {
  class: "time"
};
const _hoisted_6 = {
  key: 0,
  class: "list-card-container"
};
const _hoisted_7 = {
  class: "list-card-header vc"
};
const _hoisted_8 = {
  class: "time"
};
const _hoisted_9 = {
  style: {
    "order": "-1"
  }
};
import ExibitionCard from "./components/ExibitionCard.vue";
import HallCard from "./components/hallCard.vue";
import CardMenu from "./components/cardMenu.vue";
import { historyPage, deleteMyExibition } from "@/api/exibition";
import SzrDialog from "./components/szrDialog.vue";
import { fetchHallHistroy } from "@/api/hall";
import { usePay } from "./components/payDialog";
const __default__ = defineComponent({
  name: "myHistory"
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const loading = ref(false);
    const total = ref(0);
    let TabList;
    (function (TabList) {
      TabList[TabList["exbition"] = 0] = "exbition";
      TabList[TabList["hall"] = 1] = "hall";
    })(TabList || (TabList = {}));
    const activeTab = ref(TabList.exbition);
    const showSzrDialog = ref(false);
    const itemsId = ref("");
    const digitalId = ref("");
    const commandList = ["a", "b", "d", "r", "e", "config", "s"];
    const searchData = reactive({
      pageNum: 1,
      pageSize: 10
    });
    const dataList = ref();
    function getList() {
      historyPage(searchData, {
        loading
      }).then(({
        data
      }) => {
        dataList.value = data.list;
        total.value = data.totalCount;
      });
    }
    const hallList = ref();
    const fetchHall = () => {
      fetchHallHistroy(searchData, {
        loading
      }).then(({
        data
      }) => {
        hallList.value = data?.list || [];
        total.value = data.totalCount;
      });
    };
    watch(() => activeTab.value, val => {
      searchData.pageNum = 1;
      if (val == TabList.exbition) {
        getList();
      } else {
        fetchHall();
      }
    }, {
      immediate: true
    });
    const handleCurrentChange = () => {
      if (activeTab.value == TabList.exbition) {
        getList();
      } else {
        fetchHall();
      }
    };
    const szrEvent = data => {
      itemsId.value = data.id;
      digitalId.value = data.digitalManId;
      showSzrDialog.value = true;
    };
    const handleCommand = (command, data) => {
      if (command == "r") {
        deleteMyExibition({
          ids: [data.id]
        }, {
          loading,
          message: "删除成功"
        }).then(() => {
          getList();
        });
      }
    };
    const {
      pay,
      payFlag,
      templateId,
      exbitionId,
      paydialog
    } = usePay();
    const handleClone = data => {
      exbitionId.value = data.id;
      templateId.value = data.templateId;
      payFlag.value = "clone";
      pay.value = true;
    };
    const handleClose = () => {
      pay.value = false;
      getList();
    };
    return (_ctx, _cache) => {
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_tabs, {
        modelValue: _unref(activeTab),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(activeTab) ? activeTab.value = $event : null),
        class: "demo-tabs"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "展项",
          name: TabList.exbition
        }, {
          default: _withCtx(() => [_unref(dataList)?.length ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataList), item => {
            return _openBlock(), _createBlock(ExibitionCard, {
              class: "exibition-card",
              cardData: item,
              key: item,
              btn: ['edit', 'start']
            }, {
              header: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(item.timeDomain), 1), _createVNode(CardMenu, {
                onRefresh: getList,
                objData: item,
                onClone: $event => handleClone(item),
                "command-list": ['a', 'b', 'c', 'd', 'e', 'r', 'config', 'd'],
                onCommand: handleCommand
              }, null, 8, ["objData", "onClone"])])]),
              _: 2
            }, 1032, ["cardData"]);
          }), 128))])) : !_unref(dataList)?.length && !_unref(loading) ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 1,
            description: "暂无数据"
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["name"]), _createVNode(_component_el_tab_pane, {
          label: "展馆",
          name: TabList.hall
        }, {
          default: _withCtx(() => [_unref(hallList)?.length ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(hallList), item => {
            return _openBlock(), _createBlock(HallCard, {
              key: item.id,
              "card-data": item,
              btn: ['edit', 'details']
            }, {
              header: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(item.timeDomain), 1), _createVNode(CardMenu, {
                objData: Object.assign({}, item, {
                  type: 2
                }),
                onRefresh: fetchHall
              }, null, 8, ["objData"])])]),
              _: 2
            }, 1032, ["card-data"]);
          }), 128))])) : _createCommentVNode("", true), !_unref(hallList)?.length && !_unref(loading) ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 1,
            description: "暂无数据"
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["name"])]),
        _: 1
      }, 8, ["modelValue"])]), _unref(total) ? (_openBlock(), _createBlock(_component_el_pagination, {
        key: 0,
        layout: "prev,pager,next,slot",
        class: "pagination-theme vh ab-center-h",
        total: _unref(total),
        "current-page": _unref(searchData).pageNum,
        "onUpdate:currentPage": _cache[1] || (_cache[1] = $event => _unref(searchData).pageNum = $event),
        "page-size": _unref(searchData).pageSize,
        onCurrentChange: handleCurrentChange
      }, {
        default: _withCtx(() => [_createElementVNode("span", _hoisted_9, " 共 " + _toDisplayString(_unref(total)) + "条", 1)]),
        _: 1
      }, 8, ["total", "current-page", "page-size"])) : _createCommentVNode("", true), _createVNode(SzrDialog, {
        onClose: _cache[2] || (_cache[2] = $event => showSzrDialog.value = false),
        onRefresh: _ctx.fetchData,
        digitalId: _unref(digitalId),
        itemsId: _unref(itemsId),
        show: _unref(showSzrDialog)
      }, null, 8, ["onRefresh", "digitalId", "itemsId", "show"]), _unref(pay) ? (_openBlock(), _createBlock(_unref(paydialog), {
        key: 1,
        show: _unref(pay),
        templateId: _unref(templateId),
        exbitionId: _unref(exbitionId),
        payFlag: _unref(payFlag),
        onClose: handleClose
      }, null, 8, ["show", "templateId", "exbitionId", "payFlag"])) : _createCommentVNode("", true)])), [[_directive_loading, _unref(loading)]]);
    };
  }
});